import React, { useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import { Form, useForm } from "../../components/hooks/useForm";
import LoadingComp from "../../components/LoadingComp";

const ManageContactsSingleDetail = ({ singleContact, loadingDetail }) => {
  const initialFormValues = {
    full_name: "",
    email: "",
    phone: "",
    message: "",
    created_at: "",
  };

  const { values, setValues } = useForm(initialFormValues);

  useEffect(() => {
    if (singleContact) {
      setValues({ ...singleContact });
    }
  }, [singleContact, setValues]);

  return (
    <Form>
      {loadingDetail ? (
        <LoadingComp />
      ) : (
        <>
          <Grid container spacing={2} style={{ fontSize: "12px" }}>
            <Grid item xs={6}>
              <TextField
                InputProps={{
                  style: {
                    pointerEvents: "none",
                  },
                }}
                name="full_name"
                label="Full Name"
                style={{ width: "100%" }}
                value={values.full_name}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                InputProps={{
                  style: {
                    pointerEvents: "none",
                  },
                }}
                name="email"
                label="Email Address"
                style={{ width: "100%" }}
                value={values.email}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                InputProps={{
                  style: {
                    pointerEvents: "none",
                  },
                }}
                name="phone"
                label="Phone Number"
                style={{ width: "100%" }}
                value={values.phone}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                InputProps={{
                  style: {
                    pointerEvents: "none",
                  },
                }}
                name="message"
                label="Messages"
                value={values.message}
                multiline
                rows={6}
                style={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Form>
  );
};

export default ManageContactsSingleDetail;
